import { DEFAULT_TIME_ZONE, localDayKey } from '@wf/shared'

/** Sekunden als HH:MM:SS (negative/ungültige Werte → 00:00:00). */
export function formatHMS(totalSeconds: number): string {
  const s = Math.max(0, Math.floor(totalSeconds))
  const h = Math.floor(s / 3600)
  const m = Math.floor((s % 3600) / 60)
  const sec = s % 60
  const pad = (n: number): string => String(n).padStart(2, '0')
  return `${pad(h)}:${pad(m)}:${pad(sec)}`
}

/** Kompakte Dauer für die Karten-Fakten: "1h 30m" / "45m". (Unter einer Minute → "0m".) */
export function formatDurationShort(totalSeconds: number): string {
  const s = Math.max(0, Math.floor(totalSeconds))
  const h = Math.floor(s / 3600)
  const m = Math.floor((s % 3600) / 60)
  return h > 0 ? `${h}h ${m}m` : `${m}m`
}

/** Epoch-Millisekunden → lokale Uhrzeit "HH:MM" (für „eingestempelt seit …"). */
export function formatClock(epochMs: number): string {
  const d = new Date(epochMs)
  const pad = (n: number): string => String(n).padStart(2, '0')
  return `${pad(d.getHours())}:${pad(d.getMinutes())}`
}

/** "2026-06-17 08:00:00" / ISO → "17.06.2026". Nimmt den Datumsteil direkt aus dem String (kein UTC-Shift). */
/** Wanduhrzeit MIT Sekunden ('HH:MM:SS') in der Werkstatt-Zeitzone — für die Nachweiskette (Protokoll):
 *  mehrere revisionsrelevante Aktionen in derselben Minute müssen unterscheidbar/ordnbar bleiben. */
export function formatWallClockSec(epochMs: number): string {
  return new Intl.DateTimeFormat('de-DE', {
    timeZone: DEFAULT_TIME_ZONE,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  }).format(new Date(epochMs))
}

/** 'DD.MM.YYYY HH:MM:SS' — tz-fixierter Lokaltag + Wandzeit (NIE Geräte-Zeitzone, siehe @wf/shared). */
export function formatDateTimeDE(epochMs: number): string {
  return `${formatDateDE(localDayKey(epochMs))} ${formatWallClockSec(epochMs)}`
}

export function formatDateDE(value: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(value)
  return m ? `${m[3]}.${m[2]}.${m[1]}` : value
}
